import React, { Component } from "react";
import "react-table/react-table.css";
import "../tables/reactTable.css";
import "./CampaignTables.css";
import { Button, Drawer } from "@material-ui/core";
import EditButton from "../assets/editButton.png";
import LeftArrow from "../assets/leftArrow.png";
import { getEdit, getStepEdit } from "./campaignQueries";
import { fetchMethod } from "../../FetchMethod";
import { connect } from "react-redux";
import { SemipolarLoading } from "react-loadingg";
import EditCampaign from "../Form/EditForm";

class CampaignTablesComponent extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      show: "",
      name: "",
      openForm: false,
      editableData: undefined,
      editCampaignStepsData: undefined
    };
  }
  EditDetails = reponse => {
    this.setState({ show: reponse });
  };

  campaignTabDetailFetch = response => {};
  CampaignName = res => {
    this.setState({ name: res });
  };

  toggleDrawer = (side, open, user) => async event => {
    let data = await getEdit(this.props.campaignid);

    this.setState(
      {
        editableData:
          data.data !== undefined &&
          data.data.allCampaigns !== null &&
          data.data.allCampaigns.Campaigns[0] !== null
            ? data.data.allCampaigns.Campaigns[0]
            : ""
      },
      () => this.props.editFormData(this.state.editableData)
    );

    fetchMethod(getStepEdit(this.props.campaignid))
      .then(res => res.json())
      .then(res => {
        this.setState(
          {
            editCampaignStepsData:
              res.data !== undefined &&
              res.data.allCampaignsteps !== null &&
              res.data.allCampaignsteps.Campaignsteps !== undefined
                ? res.data.allCampaignsteps.Campaignsteps
                : ""
          },
          () => {
            this.props.onEditMode(true);
            this.props.getId(this.state.editableData.id);
            if (this.child.current !== null && this.props.campaignid) {
              this.child.current.fetchDetails(this.props.campaignid);
            }
            this.state.editCampaignStepsData.sort(function(a, b) {
              return a.sequence - b.sequence;
            });
            return this.props.OnEdit(this.state.editCampaignStepsData);
          }
        );
      })
      .catch(e => console.log(e));

    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    this.setState({ ...this.state, [side]: open });
  };
  render() {
    return (
      <div>
        <React.Fragment>
          <div className="CommonHeader">
            <div>
              <span onClick={this.props.backToCampaignMainList}>
                <img src={LeftArrow} alt="&#60" />
              </span>
              <span>
                {localStorage.getItem("role") !== "CUSTOMER"
                  ? this.state.name + " "
                  : this.props.selectedCampaignName}{" "}
                Dashboard
              </span>
            </div>

            {this.state.show === true ? (
              <span>
                {localStorage.getItem("role") !== "CUSTOMER" ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.toggleDrawer(
                      "openForm",
                      true,
                      this.props.campaignid
                    )}
                    className="EditButton"
                    startIcon={<img src={EditButton} alt="edit" />}
                  >
                    <span>E</span>
                    <span>dit</span>
                  </Button>
                ) : (
                  ""
                )}

                <Drawer
                  anchor="right"
                  open={this.state.openForm}
                >
                  {this.state.editableData ? (
                    <EditCampaign
                      title="Edit Campaign"
                      formConfig={this.props.formConfig}
                      editableData={this.state.editableData}
                      editLinkedinData={this.state.editCampaignStepsData}
                      formValidation={this.props.formValidation}
                      modalClose={this.toggleDrawer(
                        "openForm",
                        false,
                        this.props.campaignid
                      )}
                      className="EditCampaign"
                      query={this.props.query}
                      getData={this.props.getData}
                      params={this.props.params}
                      params1={this.props.params1}
                      params2={this.props.params2}
                      params3={this.props.params3}
                      buttonName={"Update"}
                      message="Campaign updated successfully"
                    />
                  ) : (
                    <div className="spinner">
                      <SemipolarLoading size={70} color={"#004379"} />
                    </div>
                  )}
                </Drawer>
              </span>
            ) : (
              ""
            )}
          </div>
         
        </React.Fragment>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    editFormData: data => dispatch({ type: "Form_data", payload: data }),
    OnEdit: editCampaignStepsData =>
      dispatch({ type: "Edit_Step_Data", StepId: editCampaignStepsData }),
    onEditMode: editMode =>
      dispatch({ type: "IsEditModeable", editMode: editMode }),
    getId: id => dispatch({ type: "GetId", id: id })
  };
};

export default connect(null, mapDispatchToProps)(CampaignTablesComponent);
